import { useEffect, useState } from "react"
import { OfficialDashboard } from "./OfficialDashboard"
import Header from "../../../Components/Header/Header"
import { useSearchParams } from "react-router-dom"
import { EducationDashboard, SchoolDashboard } from "./EducationDashboard/EducationDashboard"
import { HealthDashboard } from "./HealthDashboard/HealthDashboard"
import { EnchrochmentDashboard } from "./DashboardComponent/EnchrochmentDashboard/EnchrochmentDashboard"
import { IllegalConstructionDashboard } from "./DashboardComponent/IllegalConstructionDashboard/IllegalConstructionDashboard"

export const DakshaDashboard = () => {


    const [DashType, setDashType] = useState(localStorage.getItem('DashType') ? localStorage.getItem('DashType') : 1)

    const [YearValue, setYearValue] = useState(null)
    const [YearLabel, setYearLabel] = useState(null)
    const [MonthValue, setMonthValue] = useState(null)
    const [MonthLabel, setMonthLabel] = useState(null)
    const [WardValue, setWardValue] = useState(null)
    const [WardLabel, setWardLabel] = useState(null)
    const [ZoneValue, setZoneValue] = useState(null)
    const [ZoneLabel, setZoneLabel] = useState(null)

    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [Month, setMonth] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: localStorage.getItem('LanguageChange')
    })

    useEffect(() => {
        localStorage.setItem('DashType', "1")
        setLanguage({
            ...Language,
            DDL: [],
            ID: 0,
            Label: localStorage.getItem('LanguageChange'),
        })
    }, [])

    const [ZoneNameDDLID, setZoneNameDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: "",
    })

    console.log('DashType', DashType)
    
    return (
        <>
            <Header
                setYearValue={setYearValue}
                setMonthValue={setMonthValue}
                FinancialYear={FinancialYear}
                setFinancialYear={setFinancialYear}
                Month={Month}
                setMonth={setMonth}
                setYearLabel={setYearLabel}
                setMonthLabel={setMonthLabel}
                setWardValue={setWardValue}
                setWardLabel={setWardLabel}
                HideYearMonthDDL='Dashboard'
                Language={Language}
                setLanguage={setLanguage}
                DashType={DashType}
                setDashType={setDashType}

            />


            {
                DashType == 1 ? <OfficialDashboard LanguageID={Language?.Label} />
                    :
                    DashType == 2 ? <EducationDashboard Language={Language} />
                        :
                        DashType == 3 ? <EnchrochmentDashboard Language={Language} />
                            :
                            DashType == 4 ? <IllegalConstructionDashboard Language={Language} />
                                :
                                DashType == 5 ? <HealthDashboard Language={Language} />
                                    :
                                    <> </>
            }
        </>
    )
}
